var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkerLogoFake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1V6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22228 3.92606C6.24085 4.21869 5.33757 4.75185 4.60028 5.48914C3.43339 6.65603 2.77783 8.23868 2.77783 9.88891L15.2223 9.88892C15.2223 8.23868 14.5667 6.65603 13.3998 5.48914C12.6625 4.75185 11.7593 4.21869 10.7778 3.92606V6.51853C10.7778 7.33673 9.98189 8.00001 9.00005 8.00001C8.01821 8.00001 7.22228 7.33673 7.22228 6.51853V3.92606Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9.77778,
    width: 2.66667,
    height: 16,
    rx: 1.33333,
    transform: "rotate(90 17 9.77778)",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerLogoFake);
export default __webpack_public_path__ + "static/media/worker-logo-fake.cd1af558.svg";
export { ForwardRef as ReactComponent };